@if (liveChatService.showChatButton) {
<button
    #livechatButton
    [@blinking]="{ value: state }"
    class="chat-button {{ position }}-position"
    type="button"
    id="chat-button"
    (click)="liveChatService.launchChat()">
    <span hSrOnlyNoSnippet i18n="@@hermes_livechat.open_button_message"> Open Live chat </span>
    <h-svg-icon [name]="'livechat'"></h-svg-icon>
</button>
}
